import React from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Text } from 'rebass/styled-components';
import { Message } from '@getro/rombo';
import { NavLink } from 'react-router-dom';

const linkStyles = { color: 'text.main', textDecoration: 'underline', cursor: 'pointer' };

export const ShareContactsWarning = ({ myNetworksLink }) => (
  <Box maxWidth="600px" data-testid="share-contacts-warning">
    <Message
      type="warning"
      content={
        <Flex sx={{ flexDirection: 'column', gap: '4px' }}>
          <Text>No contacts are being shared yet.</Text>
          <Text>
            {'Go to '}
            <Box as={NavLink} to={myNetworksLink} sx={linkStyles}>
              My networks
            </Box>
            {' screen and select which networks you want to share them with.'}
          </Text>
        </Flex>
      }
    />
  </Box>
);

ShareContactsWarning.propTypes = {
  myNetworksLink: PropTypes.string.isRequired,
};
